import React, { useState, } from "react";
import { withTranslation } from "react-i18next";
import { Form, Button, Input, Select, } from "antd";
import { LeftOutlined } from '@ant-design/icons';
import { connect } from "react-redux";
import styled from "styled-components";

import Text from "components/Text";
import * as Styled from '../../styled';
import { patch, post } from "library/endpoints";
import Title from "components/Title";


const StyledCompanyLink = styled(Text)`
  &:hover {
    color: #13a9c6 !important;
  }
`;

/**
 * Delivery
 * @param {*} props 
 * @returns 
 */
const Delivery = (props) => {
  const [displayCompanyFields, setDisplayCompanyFields] = useState(false);

  const onFinish =  async (values) => {
    try {
      const dataToSend = {
        products: props.basket,
        delivery: values,
      }
      
      if (props.paymentData) {
        // Update 
        const { data } = await patch(`/frontend/basket/${props.paymentData._id}`, dataToSend);
        props.setPaymentData(data);
        props.setView('payment');
      } else {
        const { data } = await post(`/frontend/basket`, dataToSend);
        props.setPaymentData(data);
        props.setView('payment');
      }


    } catch (error) {
      console.log(error)
    }
  };
  
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <>
      <Styled.OptionsSelector
        onClick={() => props.setView('basket')}      
      >
        <div style={{ width: 30 }}>
          <LeftOutlined style={{ fontSize: 18, cursor: 'pointer', }} />
        </div>
        <Title style={{ marginBottom: 20, marginTop: -2 }} size={18}>Informations de livraison</Title>
      </Styled.OptionsSelector>

      <div style={{ width: '90%', maxWidth: 500, margin: 'auto', marginTop: 20 }}>
        <Form
          name="basic"
          labelCol={{
            span: 12,
          }}
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Nom"
            name="lastname"
            rules={[
              {
                required: true,
                message: props.t('FrontClient.Basket.Delivery.InputMandatoryError', 'Ce champ est obligatoire'),
              },
            ]}
            initialValue={props.auth.user.lastname}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Prénom"
            name="firstname"
            rules={[
              {
                required: true,
                message: props.t('FrontClient.Basket.Delivery.InputMandatoryError', 'Ce champ est obligatoire'),
              },
            ]}
            initialValue={props.auth.user.firstname}

          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Adresse"
            name="address"
            rules={[
              {
                required: true,
                message: props.t('FrontClient.Basket.Delivery.InputMandatoryError', 'Ce champ est obligatoire'),
              },
            ]}
            initialValue={props.auth.user.address}

          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Complément d'adresse"
            name="address_bis"
            rules={[
              {
                message: props.t('FrontClient.Basket.Delivery.InputMandatoryError', 'Ce champ est obligatoire'),
              },
            ]}
            initialValue={props.auth.user.address_bis}

          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Code postal"
            name="postcode"
            rules={[
              {
                required: true,
                message: props.t('FrontClient.Basket.Delivery.InputMandatoryError', 'Ce champ est obligatoire'),
              },
            ]}
            initialValue={props.auth.user.postcode}

          >
            <Input />
          </Form.Item>


          <Form.Item
            label="Ville"
            name="city"
            rules={[
              {
                required: true,
                message: props.t('FrontClient.Basket.Delivery.InputMandatoryError', 'Ce champ est obligatoire'),
              },
            ]}
            initialValue={props.auth.user.city}

          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Pays"
            name="country"
            rules={[
              {
                required: true,
                message: props.t('FrontClient.Basket.Delivery.InputMandatoryError', 'Ce champ est obligatoire'),
              },
            ]}
            initialValue={'650735128f562596c85dd2ed'}

          >
            <Select>
              {
                props.countries.map((country) => (
                  <Select.Option value={country._id}>{country.name.fr}</Select.Option>
                ))
              }
            </Select>
          </Form.Item>

          <Form.Item
            label="Téléphone"
            name="telephone"
            rules={[
              {
                message: props.t('FrontClient.Basket.Delivery.InputMandatoryError', 'Ce champ est obligatoire'),
              },
            ]}
            initialValue={props.auth.user.telephone}
          >
            <Input />
          </Form.Item>

          <StyledCompanyLink size={14} cursor="pointer" style={{ marginBottom: 10, }} underline color={"#53b297"} onClick={() => setDisplayCompanyFields(!displayCompanyFields)}>Je suis une société</StyledCompanyLink>
          
          {
            displayCompanyFields && (
              <div>
                <Form.Item
                  label="Nom de société"
                  name="company"
                  rules={[
                    {
                      message: props.t('FrontClient.Basket.Delivery.InputMandatoryError', 'Ce champ est obligatoire'),
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="N° de SIRET"
                  name="siret"
                  rules={[
                    {
                      message: props.t('FrontClient.Basket.Delivery.InputMandatoryError', 'Ce champ est obligatoire'),
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </div>
            )
          }
          

          <Form.Item>
            <Button type="primary" htmlType="submit" style={{ width: '100%', marginBottom: 20  }}>
              Etape suivante
            </Button>
          </Form.Item>
        </Form>
      </div>
      
    </>
  )
}

const stateToProps = state => ({
  auth: state.auth
})

export default connect(stateToProps)(withTranslation()(Delivery));